import * as commonServices from "./common";
import * as toast from "../Wrapper/toast/toast";
import axios from "axios";
import {
  SUCCESS_CODE,
  UNAUTHORIZED_ERROR_CODE,
  RESOURCE_CREATED,
  ERROR_CODE,
} from "../Constants/responseCodes";
import { trackAPITime } from "../helpers/analytics";

const getErrorResponse = (response) => {
  return {
    isSuccess: false,
    message: response?.data?.message || "Something went wrong!",
    code: response?.status || 500,
    data: response?.data || null,
  };
};

export function handleResponse(resp, startTime, url) {
  const endTime = Date.now();
  const apiTime = endTime - startTime;
  trackAPITime(apiTime, url, SUCCESS_CODE);

  let response = resp ?? {};

  if (response?.data) {
    if (
      (response?.status === SUCCESS_CODE || response?.status === RESOURCE_CREATED) &&
      response?.data?.code === SUCCESS_CODE
    ) {
      response.data.isSuccess = true;
      return response.data;
    } else if (response?.status === UNAUTHORIZED_ERROR_CODE) {
      commonServices.clearLocalStorageData();
      window.location.href = "/";
      toast.warn(response?.data?.message);
      return;
    } else {
      return getErrorResponse(response);
    }
  } else {
    return getErrorResponse(response);
  }
}

export function handleError(err, startTime, url) {
  const endTime = Date.now();
  const apiTime = endTime - startTime;
  trackAPITime(apiTime, url, "ERROR");

  let error = err ?? {};

  // Case: Axios Cancelled Request
  if (axios.isCancel(error)) {
    return {
      isSuccess: false,
      code: "CANCELLED",
    };
  }

  // Extended network error check
  const networkErrorCodes = ["ECONNABORTED", "ENETUNREACH", "ERR_NETWORK", "ETIMEDOUT"];

  // Check for no internet (offline or network failure)
  if (!window.navigator.onLine || networkErrorCodes.includes(error?.code)) {
    return {
      isSuccess: false,
      message: "No internet connection",
      code: "NO_INTERNET",
      isOffline: true,
    };
  }

  let { response } = error;

  if (response?.data) {
    if (response?.status === UNAUTHORIZED_ERROR_CODE) {
      commonServices.clearLocalStorageData();
      window.location.href = "/";
      toast.warn(response?.data?.message);
      return;
    } else if (response?.status === ERROR_CODE) {
      response.data.isSuccess = false;
      return response.data;
    } else {
      return getErrorResponse(response);
    }
  } else {
    return {
      isSuccess: false,
      message: error?.message || "Something went wrong!",
      code: error?.code || 500,
    };
  }
}
